<template>
  <div>
    <div>
      <div class="tomb-tab tomb-main tomb-tab-shadow linebottom" style="margin-top: 0px;">
        <div class="searchDiv">
          <div class="mourn_search1_inner">
            <span @click="search()" class="weui_icon_search icon iconfont">&#xe8b9;</span>
            <input
              v-model="keyword"
              type="search"
              class="mourn_search1_input"
              id="search_input"
              placeholder="搜索馆名"
              style="height: 2.5rem;"
            />
          </div>
        </div>
        <div class="menuDiv" style="background: #fbeddd;color:#333;">
          <lz-menu
            :menuItems="menuItems"
            :iActiveColor="iActiveColor"
            :iColor="iColor"
            :DefaultIndex="menuIndex"
            @clickLzMenuItem="clickMenuItem"
          />
        </div>
      </div>
      <div class="main_listing">
        <div class="listing-box">
          <div class="tomb-item tomb-item-famous">
            <div class="am-list am-list-view-scrollview">
              <div class="am-pull-to-refresh-content-wrapper">
                <div
                  class="am-pull-to-refresh-content am-pull-to-refresh-down am-pull-to-refresh-transition"
                  style="transform: translate3d(0px, 0px, 0px);"
                >
                  <div>
                    <div class="am-list-body">
                      <div class="list-view-section-body">
                        <template v-for="(item, index) in list">
                          <div
                            @click="gotoJnt(item.category, item.id)"
                            class="item-a item-slide"
                            :key="index"
                          >
                            <div class="item-img">
                              <img :src="item.firstPhoto" />
                            </div>
                            <div class="item-desc">
                              <div class="title TextChangeToTwoLines">
                                {{ item.title }}
                              </div>
                              <div class="intro TextChangeToTwoLines">
                                <template v-if="$properties(item.category,'value')=='siren'">
                                  {{ fmtHallDeath(item.firstDeathDate) }}
                                </template>
                                <template v-else>
                                  {{ item.subtitle }}
                                </template>
                              </div>
                              <div class="intro-bot">
                                <div class="bot-counts">
                                  <span class="view"
                                    ><i class="icon-view"></i
                                    ><span>{{ item.browserCount }}</span></span
                                  ><span class="love"
                                    ><i class="icon-love"></i
                                    ><span>{{ item.candleCount }}</span></span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="am-list-footer">
                      <div style="padding: 5px; text-align: center;">没有更多数据了</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LzMenu from './Menu.vue'
import moment from 'moment'
export default {
  name: 'agreement',
  components: {
    LzMenu,
  },
  data() {
    return {
      keyword: '',
      pageName: '',
      list: [],
      menuIndex: -1,
      menuItems: [
        {
          id: 1,
          name: '推荐馆',
          path: 'tuijian',
        },
        {
          id: 2,
          name: '私人馆',
          path: 'siren',
        },
        {
          id: 3,
          name: '名人馆',
          path: 'mingren',
        },
        {
          id: 4,
          name: '伟人馆',
          path: 'weiren',
        },
        {
          id: 5,
          name: '英雄馆',
          path: 'yingxiong',
        },
        {
          id: 6,
          name: '事件馆',
          path: 'shijian',
        },
        {
          id: 7,
          name: '院士馆',
          path: 'yuanshi',
        },
        {
          id: 8,
          name: '陵园',
          path: 'lingyuan',
        },
      ],
      iActiveColor: '#e4803c', //选中时文本为黄色
      iColor: '#333',
    }
  },

  created() {
    this.changeType()
  },
  mounted() {
    this.pageName = this.$route.params.type
    this.queryHallPage(1)
  },
  methods: {
    fmtHallDeath(deathDate) {
      var startDate = moment(deathDate, 'YYYY-MM-DD HH:mm:ss')
      var endDate = moment(new Date())
      var years = endDate.diff(startDate, 'year')
      var days = endDate.diff(startDate.add(years, 'years'), 'day')
      return 'TA已经离开我们' + years + '年' + days + '天'
    },
    search() {
      this.$router.push({ path: '/jnt/list/' + this.keyword })
      this.changeType()
      this.queryHallPage()
    },
    changeType(){
      this.menuIndex = -1
      this.pageName = this.$route.params.type
      for (var index in this.menuItems) {
        var item = this.menuItems[index]
        if (item['path'] == this.pageName) {
          this.menuIndex = Number(index)
        }
      }
      if (this.menuIndex == -1) {
        //搜索，菜单不做定位
        this.keyword = this.$route.params.type
      }
    },
    queryHallPage(page) {
      var that = this
      if(!page){
        page = 1
      }
      if (page == 1) {
        that.list = []
      }
      var param = { page: page }
      if(this.menuIndex == -1){
        param['lk_title'] = this.keyword
      } else {
        if (this.pageName == 'tuijian') {
          param['recommend'] = 1
        } else {
          param['category'] = this.pageName
        }
      }
      if('siren'==param['category']){
        param['accessType'] = 'public'
      } else {
        delete param['accessType']
      }
      this.$queryPage(
        'HallInfo',
        param,
        ['id,category,firstPhoto,firstDeathDate,title,subtitle,browserCount,candleCount'],
        function(res) {
          that.$fill(that.list, res['data'])
        }
      )
    },
    // addHallCandle(id) {
    //   this.$plus('HallInfo', { id: id }, ['browserCount'])
    // },
    gotoJnt(type, id) {
      // this.addHallCandle(id)
      var category = id
      if (type) {
        category = type.value
      }
      this.$router.push({ path: '/jnt/detail/' + category + '/' + id })
    },
    clickMenuItem: function(item) {
      //item
      if (item.path) {
        this.$router.push({ path: '/jnt/list/' + item.path })
        this.changeType()
        this.queryHallPage()
      } else {
        this.$router.push({ path: '/jnt' })
      }
    },
  },
  watch: {},
}
</script>

<style>
.tomb-tab {
  background: #fff;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.tomb-main {
  margin-top: 10px;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.tomb-main .tomb-nav {
  list-style: none;
  font-size: 1.4rem;
  padding: 0.685rem;
  background: #fff;
  overflow: hidden;
  padding-left: 0;
}
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  margin: 0 auto;
}
.swiper-container-android .swiper-slide,
.swiper-wrapper {
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -o-transform: translate(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  -ms-transition-property: -ms-transform;
  transition-property: transform;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.tomb-main .tomb-nav .tomb-nav-slide {
  width: auto;
  padding: 0 5px;
  letter-spacing: 2px;
  text-align: center;
  color: #333;
  padding-right: 0.5rem;
  position: relative;
}
.swiper-slide {
  -webkit-flex-shrink: 0;
  -ms-flex: 0 0 auto;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.tomb-main .tomb-nav .tomb-nav-slide span {
  display: block;
  padding: 0 0.9rem;
  line-height: 2.4rem;
  padding-top: 1px;
  padding-left: 1rem;
}
.tomb-main .tomb-nav .active span {
  transform: scale(1.05);
  color: #e4803c;
  background: #fbeddd;
  padding: 0.4rem 0.9rem;
  border-radius: 15px;
}
.tomb-tab-shadow:after {
  content: '';
  box-shadow: 0 3px 10px 6px rgb(0 0 0 / 4%);
}
.linebottom:after {
  content: '\20';
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5) translate(0, 1px);
  -webkit-transform-origin: 0 0;
  transform: scaleY(0.5) translate(0, 1px);
  transform-origin: 0 0;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.listing-box {
  padding: 0;
}
.am-pull-to-refresh-content-wrapper {
  overflow: hidden;
}
.am-pull-to-refresh-transition {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
.am-pull-to-refresh-content {
  -webkit-transform-origin: left top 0;
  -ms-transform-origin: left top 0;
  transform-origin: left top 0;
}
@media (-webkit-min-device-pixel-ratio: 2),
  (min-resolution: 2dppx) html:not([data-scale]) .am-list-body {
  border-bottom: none;
}
@media (-webkit-min-device-pixel-ratio: 2),
  (min-resolution: 2dppx) html:not([data-scale]) .am-list-body {
  border-top: none;
}
.tomb-item .am-list-body {
  background-color: #f4f4f4;
  padding-top: 15px;
}
.am-list-body {
  position: relative;
  background-color: #fff;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
  (min-resolution: 2dppx) and (min-resolution: 3dppx) html:not([data-scale]) .am-list-body:before {
  -webkit-transform: scaleY(0.33);
  -ms-transform: scaleY(0.33);
  transform: scaleY(0.33);
}
@media (-webkit-min-device-pixel-ratio: 2),
  (min-resolution: 2dppx) html:not([data-scale]) .am-list-body:before {
  content: '';
  position: absolute;
  background-color: #ddd;
  display: block;
  z-index: 1;
  top: 0;
  right: auto;
  bottom: auto;
  left: 0;
  width: 100%;
  height: 1px;
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.tomb-item .am-list-body:before {
  background-color: inherit !important;
}
.am-list-body:after,
.am-list-body:before {
  background-color: inherit !important;
}
.tomb-item .item-slide {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  display: flex;
}
.tomb-item .item-a {
  padding: 1.363rem;
  position: relative;
  text-decoration: none;
}
.tomb-item .item-img,
.tomb-item .item-img-pray {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.tomb-item .item-img {
  background: #f4f4f4;
  width: 9.095rem;
  height: 10.095rem;
}
.tomb-item .item-img-pray img,
.tomb-item .item-img img {
  height: 100%;
  width: 100%;
}
.index-head .sheet-main .item-head-img img,
.tomb-item .item-img img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  width: 100%;
  height: 100%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}
img {
  border: 0;
}
.tomb-item .item-desc {
  -ms-flex-direction: column;
  -ms-flex-pack: justify;
  -webkit-flex-direction: column;
  -webkit-justify-content: space-between;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  width: calc(100% - 8.909rem);
  margin-top: 0.5rem;
}
.tomb-item .item-desc .title {
  color: #333;
  font-size: 1.4rem;
  line-height: 1.3;
  margin-top: -3px;
  position: relative;
  padding: 0 !important;
}
.TextChangeToTwoLines {
  -webkit-line-clamp: 2;
}
.TextChangeToOneLines,
.TextChangeToTwoLines {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.tomb-item .item-desc .intro {
  color: #666;
  font-size: 1.2rem;
  line-height: 22px;
  margin-top: -3px;
}
.TextChangeToTwoLines {
  -webkit-line-clamp: 2;
}
.TextChangeToOneLines,
.TextChangeToTwoLines {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.tomb-item .item-desc .intro-bot {
  -ms-flex-align: end;
  -ms-flex-pack: justify;
  -webkit-align-items: flex-end;
  -webkit-justify-content: space-between;
  align-items: flex-end;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.tomb-item .item-desc .intro-bot .bot-counts {
  color: #666;
  font-size: 1.2rem;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.tomb-item .item-desc .intro-bot .bot-counts .love,
.tomb-item .item-desc .intro-bot .bot-counts .view {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
}
.tomb-item .item-desc .intro-bot .bot-counts .view {
  margin-right: 10px;
}
.tomb-item .item-desc .intro-bot .bot-counts .icon-view {
  height: 20px;
  width: 20px;
  background: url(../../assets/jnt/view.png) no-repeat;
  background-size: 100% 100%;
  margin-right: 2px;
  position: relative;
  top: 1px;
}
.tomb-item .item-desc .intro-bot .bot-counts .love span,
.tomb-item .item-desc .intro-bot .bot-counts .view span {
  position: relative;
  top: 1.5px;
}
.tomb-item .item-desc .intro-bot .bot-counts .love,
.tomb-item .item-desc .intro-bot .bot-counts .view {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
}
.tomb-item .item-desc .intro-bot .bot-counts .icon-love {
  height: 20px;
  width: 20px;
  background: url(../../assets/jnt/hot.png) no-repeat;
  position: relative;
  background-size: 100% 100%;
  margin-right: 2px;
}
@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
  (min-resolution: 2dppx) and (min-resolution: 3dppx) html:not([data-scale]) .am-list-body:after {
  -webkit-transform: scaleY(0.33);
  -ms-transform: scaleY(0.33);
  transform: scaleY(0.33);
}
@media (-webkit-min-device-pixel-ratio: 2),
  (min-resolution: 2dppx) html:not([data-scale]) .am-list-body:after {
  content: '';
  position: absolute;
  background-color: #ddd;
  display: block;
  z-index: 1;
  top: auto;
  right: auto;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  -webkit-transform-origin: 50% 100%;
  -ms-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.am-list-body:after,
.am-list-body:before {
  background-color: inherit !important;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.am-list-footer {
  padding: 9px 15px 15px;
  font-size: 14px;
  color: #888;
}
/* 搜索 */

.mourn_search1_bar {
  position: relative;
  padding: 8px 10px;
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
  background-color: #faf9fa;
}

.mourn_search1_bar:before {
  top: 0;
  border-top: 1px solid #c7c7c7;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}

.mourn_search1_bar:after,
.mourn_search1_bar:before {
  content: ' ';
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  color: #c7c7c7;
}

.mourn_search1_bar:after {
  bottom: 0;
  border-bottom: 1px solid #c7c7c7;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}

.mourn_search1_bar.mourn_search1_focusing .mourn_search1_cancel {
  display: block;
}

.mourn_search1_bar.mourn_search1_focusing .mourn_search1_text {
  display: none;
}

.mourn_search1_outer {
  position: relative;
  flex: auto;
  -webkit-flex: auto;
}

.mourn_search1_outer:after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: 0 0;
  -webkit-transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  border-radius: 40px;
  border: 1px solid #eee;
  box-sizing: border-box;
  background: #eee;
}
.mourn_search1_inner {
  position: relative;
  padding-left: 20px;
  padding-right: 30px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  border-radius: 20px;
  border: 1px solid #e4803c;
  background: #ffffff;
}

.mourn_search1_inner .mourn_search1_input {
  padding: 4px 0;
  width: 100%;
  height: 1.42857143em;
  border: 0;
  font-size: 14px;
  line-height: 1.42857143em;
  box-sizing: content-box;
  background: transparent;
}

.mourn_search1_inner .mourn_search1_input:focus {
  outline: none;
}

.mourn_search1_inner .weui_icon_search {
  position: absolute;
  right: 20px;
  top: 2px;
  line-height: 28px;

  color: #333;
}

.mourn_search1_inner .weui_icon_clear {
  position: absolute;
  top: 4px;
  right: 0;
  padding: 0 10px;
  line-height: 28px;
}

.mourn_search1_text {
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  left: 1px;
  z-index: 2;
  border-radius: 3px;
  text-align: center;
  color: #9b9b9b;
  background: #fff;
}

.mourn_search1_text span {
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
}

.mourn_search1_text .weui_icon_search {
  margin-right: 5px;
}

.mourn_search1_cancel {
  display: none;
  margin-left: 10px;
  line-height: 28px;
  white-space: nowrap;
  color: #fff;
}

.mourn_search1_input:not(:valid) ~ .weui_icon_clear {
  display: none;
}

input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
  display: none;
}
</style>
